import { render, staticRenderFns } from "./ModalInsert.vue?vue&type=template&id=e80da95e&scoped=true"
import script from "./ModalInsert.vue?vue&type=script&lang=js"
export * from "./ModalInsert.vue?vue&type=script&lang=js"
import style0 from "./ModalInsert.vue?vue&type=style&index=0&id=e80da95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80da95e",
  null
  
)

export default component.exports